export default function useIOSDetection() {
    const isIos = (): boolean => {
        if (typeof window === "undefined" || typeof navigator === "undefined") return false;
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    };

    const isInStandaloneMode = (): boolean =>
        "standalone" in window.navigator &&
        Boolean((window.navigator as any).standalone);

    const showInstallMessage = isIos() && !isInStandaloneMode();

    return {
        showInstallMessage,
        isIos,
    };
}